"use client";
import SectionPage from "@/components/common/section-page";

import {Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList,} from "@/components/ui/breadcrumb";
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import CiInteractiveMap, {ciInteractiveMapMarkers,} from "@/components/site-officiel/accueil/ci-interactive-map";
import { useNavigate } from "react-router-dom";
import ImageGallery from "@/components/common/image-gallery";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className={"flex flex-col gap-6 pb-6 bg-slate-100"}>
      <CardTitle
        title={"Nos Régions"}
        backgroundImgSrc={"/images/card-title/Nos-Regions.jpg"}
      />

      {/* Breadcrumb */}
      <SectionPage sectionType="2xl">
        <div className={"flex justify-between items-center"}>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href={"/"}>Nos Régions</BreadcrumbLink>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </SectionPage>

      {/* Présentation */}
      <SectionPage sectionType="2xl">
        <AwesomeCard
          title={"LE CENTRE : L’ART DE VIVRE EN COULEUR"}
          className={"bg-white text-muted-foreground"}
          titleClassName={"text-bleu-marine"}
        >
          Yamoussoukro, ville majestueuse avec sa basilique Notre Dame de la
          Paix, symbolise le brassage ethnoculturel. Les principales
          infrastructures, plus imposante les unes des autres sont : la
          Préfecture au Nord, la Préfecture au nord, la Fondation au sud,
          l’Hôtel président à l’est et la Basilique à l’ouest. Les premières
          lettres de chaque édifice mises bout à bout forment les initiales du
          Président Félix Houphouët-Boigny.
          <br />
          <br />
          Yamoussoukro est aussi une ville carrefour et cosmopolite, situé au
          centre de la Côte d’Ivoire dans le V Baoulé. La population est un
          savant mélange de peuples d’origines diverses. L’art du tissage du
          Tanny (pagne artisanal) et la gastronomie du terroir attire de
          nombreux visiteurs.
        </AwesomeCard>
      </SectionPage>

      {/* galerie */}
      <SectionPage sectionType="2xl">
        <AwesomeCard className={"bg-white"} titleClassName={"text-bleu-marine"}>
          <div className={'mt-8'}>
            <ImageGallery images={
              Array.from({ length: 3 }).map((_, index) => ({
                src: `/images/nos-regions/centre${index + 1}.jpg`,
                alt: `image${index + 1}`,
                width: 700,
                height: 700,
              }))
            } aspectRatio={"video"} gridClassName={"grid grid-cols-1 md:grid-cols-3 gap-4"} />
          </div>
        </AwesomeCard>
      </SectionPage>

      {/* Villes et Régions */}
      <SectionPage sectionType="2xl">
        <AwesomeCard
          title={"Villes et Régions"}
          className={"bg-white text-muted-foreground"}
          titleClassName={"text-bleu-marine"}
        >
          <div className={"flex justify-center w-full"}>
            <CiInteractiveMap
              strokeColor={"#ffffff"}
              markers={ciInteractiveMapMarkers(navigate)}
            />
          </div>
        </AwesomeCard>
      </SectionPage>
    </div>
  );
}
